<template #body>
	<iframe v-if="iframe_url && iframe_url != ''" :src="`${iframe_url}?data=${base64Params}`" title="urlAction"></iframe>
</template>

<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'
	import { storage } from '@/services/storage'
	import { s3Filesystem }   from "@/services/axios"




	export default {
		components: { uiCard, uiButton, uiInput, uiLoadSuccess, uiLoadIndicator },
		data() {
			return {
				url_actions: null,
				iframe_url: null,
				url_params:  { 
				user: storage.get('user_logged'),
				instance: storage.get('get-configs-data').instance
			},
			}
		},
		created() {
			let user = JSON.parse(storage.get('user_logged'));
			let config = JSON.parse(storage.get('api_config'));

			s3Filesystem.getAdvancedConfigs()
				.then(response => {
					this.url_actions = response.data.url_actions;
					this.url_params = {
						id: user.id,
						first_name:user.first_name,
						identity: user.identity,
						user_group: user.user_group,
						instance: config.instance
					};
					this.findUrlById(); // Chamar findUrlById após obter os dados de action_urls
				})
				.catch(error => {
					if (error?.data?.msg) this.$toastr.e(error.data.msg);
					console.log(error);
				});
		},
		watch: {
			'$route.params.id': function(newId, oldId) {
				this.findUrlById()
			},
		},
		mounted() {
			this.findUrlById()
		},
		computed: {
			base64Params() {
			const jsonData = JSON.stringify(this.url_params);
			return btoa(jsonData); // Converte para base64
			},
		},
		methods: {
			/*
			* Acha em url_actions o item que possui o campo id igual ao id que vem como parâmetro na rota
			*/
			findUrlById() {
				const id = this.$route.params.id;
				const matchedAction = this.url_actions.find(action => action.id === id);
				if (matchedAction && matchedAction.url != "") {
					this.iframe_url = matchedAction.url;
				} else {
					this.$toastr.e('Erro ao carregar o iFrame. URL Não configurada.');
					this.iframe_url = matchedAction.url;
				}
			}

		}	
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
